"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
const gotti_1 = require("gotti");
const Component_1 = require("../Systems/Tree/Component");
const Position_1 = require("../../Shared/Components/Position");
class Tree extends gotti_1.Entity {
    constructor(treeSeq) {
        super(treeSeq, 'tree');
    }
    initialize(data) {
        this.addComponent(new Position_1.Position(data.position.x, data.position.y));
        this.addComponent(new Component_1.TreeComponent(data.treeTypeIndex));
    }
}
exports.Tree = Tree;
//# sourceMappingURL=module.js.map